import api from './client.js'

export const modulesAPI = {
  getEnabled: () => api.get('/modules/enabled'),
  getAll: () => api.get('/modules'),
  toggle: (moduleKey) => api.patch(`/modules/${moduleKey}/toggle`),
  bulkUpdate: (modules) => api.put('/modules/bulk-update', { modules }),
}

/* Per-item sidebar-verbergen — los van de module-toggle (die de hele
   module + routes uitschakelt). Deelnemers zien verborgen items niet;
   admins zien ze mét een "verborgen"-badge zodat ze de module blijven
   kunnen configureren. */
export const menuVisibilityAPI = {
  getHidden: () => api.get('/menu-visibility'),                            // publiek
  adminList: () => api.get('/menu-visibility/admin'),                      // admin
  adminSet:  (item_path, is_hidden) =>
    api.put('/menu-visibility/admin', { item_path, is_hidden: !!is_hidden }),
}

/* Onderhouds-modus — admin/superadmin zet de app achter een full-screen
   overlay voor deelnemers. Admin blijft normaal werken. Gepolld elke 60s
   via de gate zodat een toggle binnen een minuut effect heeft. */
export const maintenanceAPI = {
  get:      () => api.get('/maintenance'),                                 // publiek
  adminSet: (payload) => api.put('/maintenance/admin', payload),           // admin
}

export const settingsAPI = {
  getSecurity:    ()   => api.get('/settings/security'),
  getPublicMode:  ()   => api.get('/settings/public-mode'),
  setPublicMode:  (v)  => api.put('/settings/public-mode', { public_mode: !!v }),
  setSecurity:  (v)  => api.put('/settings/security', { registration_enabled: !!v }),
  getTheme:     () => api.get('/settings/theme'),
  getBranding:  () => api.get('/settings/branding'),
  setBranding:  (data) => api.put('/settings/branding', data),
  uploadBrandingLogo: (file) => {
    const fd = new FormData(); fd.append('file', file)
    return api.post('/settings/branding/logo', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  setTheme: (theme) => api.put('/settings/theme', { theme }),
}

export const serviceConfigAPI = {
  getOverview: () => api.get('/service-config/overview'),
  getAll: () => api.get('/service-config'),
  update: (key, value) => api.patch(`/service-config/${key}`, { value }),
  check: (key) => api.post(`/service-config/${key}/check`),
}

export const networkAPI = {
  getNetworkInfo: () => api.get('/network/info'),
  ping: () => api.get('/network/ping'),
  speedTestDownload: (sizeMB = 10) => api.get(`/network/speed-test/download?size=${sizeMB}`, {
    responseType: 'blob',
  }),
  speedTestUpload: (data) => api.post('/network/speed-test/upload', data, {
    headers: { 'Content-Type': 'application/octet-stream' },
  }),
  testInternetSpeed: () => api.get('/network/speed-test/internet'),
}
